<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';

import Navbar from '@/components/Navbar.vue';
import NextStep from '@/components/NextStep.vue';

import { CheckoutFlowStep, useCheckoutFlow } from '@/composables/useCheckoutFlow';
import { useWarehouseInfo } from '@/composables/useWarehouseInfo';

const checkoutFlow = useCheckoutFlow();
const { isLoading, fetchAndStoreWarehouseInfo } = useWarehouseInfo();

const showStepNavigation = computed(() => checkoutFlow.step.value !== CheckoutFlowStep.WelcomePage);
const isWarehouseLoading = computed(() => isLoading.value);

onMounted(async () => {
  await fetchAndStoreWarehouseInfo();
});
</script>

<template>
  <div class="page fill-height d-flex flex-column gap-6 pt-4">
    <navbar primary class="px-4" />

    <div
      v-if="isWarehouseLoading"
      class="d-flex flex-column align-center justify-center gap-4 py-16 my-auto">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      <p class="text-body-1 text-grey">Loading warehouse information, please wait...</p>
    </div>

    <div
      v-else
      class="d-flex flex-column gap-6 px-4"
      v-bind:class="checkoutFlow.step.value === CheckoutFlowStep.WelcomePage && 'my-auto'">
      <v-btn
        v-if="showStepNavigation"
        variant="text"
        prepend-icon="mdi-arrow-left"
        style="align-self: flex-start"
        @click="checkoutFlow.goToPreviousStep()">
        Back
      </v-btn>
      <component :is="checkoutFlow.getCurrentStepComponent(checkoutFlow.step)" />
    </div>
  </div>
  <next-step
    v-if="showStepNavigation"
    :current-step="checkoutFlow.step"
    :is-step-valid="checkoutFlow.validateStep(checkoutFlow.step.value)"
    :go-to-next-step="checkoutFlow.goToNextStep" />
</template>
